<div class="Link" *ngFor="let link of subHeader.children; let i=index" [ngClass]="i > 0 ? 'Link-paddingLeft' : ''">
    <button class="Link-button"
      (click)="routePage(link,subHeader.path);"
      [ngClass]="getHighlighterClass(i, link, pageIdentifier)"
      data-cy="search-links"
    >
      {{ link.id === 'ourDealerships' ? ('aboutUs/aboutTitleB' | lowercase | translate) : link.label | lowercase | translate }}
    </button>
</div>
